import { connect } from '@atlassian/jira-react-redux';
import { getCurrentEstimationStatistic } from '../../state/selectors/chart';
import { getSprints } from '../../state/selectors/sprints';
import { getTimeTrackingOptions } from '../../state/selectors/time-tracking-options';
import type { State } from '../../state/types';
import Grid, { type Props } from './view';

const mapStateToProps = (state: State): Props => ({
	sprints: getSprints(state),
	timeTrackingOptions: getTimeTrackingOptions(state),
	estimationStatistic: getCurrentEstimationStatistic(state),
});

export default connect(mapStateToProps, {})(Grid);
